export default __webpack_public_path__ + "static/media/agriculture.fa51455e.svg";